import React from "react";
import { format, parse, isValid } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const FMT = "dd/MM/yyyy";

function toDate(value) {
  if (!value) return undefined;
  const d = parse(value, FMT, new Date());
  return isValid(d) ? d : undefined;
}

// Touch-friendly date field: tapping opens a calendar; stores "dd/MM/yyyy".
export function DatePickerField({ value, onChange, testId, placeholder = "Choisir une date" }) {
  const [open, setOpen] = React.useState(false);
  const selected = toDate(value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="flex h-11 w-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 text-left text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200">
          <CalendarIcon className="h-4 w-4 shrink-0 text-amber-500" />
          <span className={value ? "" : "text-slate-400"}>{value || placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={fr}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            onChange(d ? format(d, FMT) : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
